import styled from "styled-components";
import { ChangeEvent, MessageGroupData } from "../../../globals/interfaces";
import GroupsTable from "./GroupsTable";
import { Label } from "reactstrap";
import { Input } from "reactstrap";
import ActionIcon from "../../../components/custom/ActionIcon";
import { useState } from "react";

export default function SendMessage ({
    groups,
    setSelectedGroup,
    sendMessage
}: {
    groups: Array<MessageGroupData>;
    setSelectedGroup: React.Dispatch<React.SetStateAction<MessageGroupData | undefined>>;
    sendMessage: (message: string) => Promise<void>;
}) {

    const [message, setMessage] = useState('');
    const handleSendMessage = async () => {
        await sendMessage(message);
        setMessage('');
    }

    return (
        <FlexContainer>
            <GroupsTable
                groups={groups}
                setSelectedGroup={setSelectedGroup}
                handleCreateUpate={() => {}}
                tableIndex={0}
            />
            <div>
                <Label>Message</Label>
                <Input 
                    type={'textarea'} 
                    value={message} 
                    onChange={(e: ChangeEvent) => setMessage(e.target.value)} 
                    style={{
                        width: '500px',
                        height: '500px'
                    }}
                    className={'normal-text'}
                />
                <RightAlign>
                    <ActionIcon 
                        type="save"
                        onClick={handleSendMessage}
                    />
                </RightAlign>
            </div>
        </FlexContainer>
    );
}

const FlexContainer = styled.div`
    display: flex;
    gap: 100px;
`;

const FlexBetween = styled.div`
    display: flex;
    justify-content: space-between;
`;

const RightAlign = styled.div`
    text-align: right;
`;
